import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { actions } from '../../EmailSettingsState'
import { useSelector } from 'src/utils/store'
import * as S from './EmailSetup.styles'
import EmailSetupButton from '../EmailSetupButton/EmailSetupButton'

const EmailSetup = () => {
  const dispatch = useDispatch()
  const emailUser = useSelector((state) => state.emailSettings.email)
  useEffect(() => {
    dispatch(actions.getUserEmail({}))
  }, [dispatch])

  return (
    <S.Container>
      <h6>E-mail atual:</h6>
      <p>{emailUser || 'Nenhum e-mail atual encontrado'}</p>
      <EmailSetupButton />
    </S.Container>
  )
}

export default EmailSetup
